import React from 'react';

const styles = {
  card: {
    background: 'var(--bg2)',
    border: '1px solid var(--border)',
    borderRadius: '16px',
    padding: '20px 24px',
  },
  metric: {
    background: 'var(--bg3)',
    borderRadius: '14px',
    padding: '16px 18px 18px',
  },
  title: {
    fontSize: '12px',
    fontWeight: 600,
    color: 'var(--text2)',
    marginBottom: '8px',
  },
  value: {
    fontSize: '26px',
    fontWeight: 800,
    color: 'var(--text1)',
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    whiteSpace: 'nowrap',
  },
  sub: {
    fontSize: '12px',
    color: 'var(--text2)',
    marginTop: '6px',
  },
};

export function MetricCard({ title, value, sub, color, footer }) {
  return (
    <div style={{
      ...styles.metric,
      ...(footer ? { display: 'flex', flexDirection: 'column' } : null),
    }}>
      <div style={styles.title}>{title}</div>
      <div style={{ ...styles.value, color: color || 'var(--accent)' }}>{value || '—'}</div>
      {sub && <div style={styles.sub}>{sub}</div>}
      {footer && <div style={{ marginTop: 'auto' }}>{footer}</div>}
    </div>
  );
}

export function Card({ title, children, action, style }) {
  return (
    <div style={{ ...styles.card, ...style }}>
      {(title || action) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          {title && <div style={{ fontSize: '16px', fontWeight: 800, letterSpacing: '-0.01em' }}>{title}</div>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Plate({ children }) {
  return <div className="kp-plate"><span>{children}</span></div>;
}
